export const startOfLocalDay = (date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

export const endOfLocalDay = (date) => {
  const next = new Date(date);
  next.setHours(23, 59, 59, 999);
  return next;
};

/** Inclusive calendar-day range for redemption reporting (matches list + dashboard). */
export const buildRedemptionDateUtcFilter = (fromDate, toDate) => {
  if (!fromDate && !toDate) return null;

  const range = {};
  if (fromDate) {
    range.$gte = startOfLocalDay(fromDate).toISOString();
  }
  if (toDate) {
    range.$lte = endOfLocalDay(toDate).toISOString();
  }
  return range;
};
